import { Fragment, useCallback, useState } from "react";
import { styled } from "styled-components";
import { useNavigate } from "react-router-dom";
import { StyledButton } from "./Typography";
import { Modal } from "./Modal";
import { useAuth, useUI } from "../contexts";

const StyledLogout = styled(StyledButton)`
  display: flex;
  align-items: center;
  margin-left: auto;
`;

const LogoutButton = () => {
  const [modalLogoutActive, setModalLogoutActive] = useState<boolean>(false);
  const { user, logout } = useAuth();
  const { setIsMobileMenuOpen } = useUI();
  const navigate = useNavigate();

  const onLogIn = useCallback(() => {
    setIsMobileMenuOpen(false);
    navigate("/login");
  }, [navigate, setIsMobileMenuOpen]);

  const toggleModal = useCallback(
    (event: boolean) => () => setModalLogoutActive(event),
    [],
  );

  const handleSignOut = useCallback(async () => {
    setModalLogoutActive(false);
    setIsMobileMenuOpen(false);
    await logout();
    navigate("/");
  }, [logout, navigate, setIsMobileMenuOpen]);

  return (
    <Fragment>
      <StyledLogout onClick={user ? toggleModal(true) : onLogIn}>
        {user ? "Odhlásit" : "Přihlášení"}
      </StyledLogout>
      <Modal
        open={modalLogoutActive}
        onClose={toggleModal(false)}
        cancelText="Zrušit"
        okText="Odhlásit"
        title="Opravdu se chcete odhlásit ?"
        onOk={handleSignOut}
      />
    </Fragment>
  );
};

export default LogoutButton;
